
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";

import VisitCreateForm from "@/form/visits/visitCreate";

import VisitCreateModalForm from "@/UI/components/forms/visits/create/VisitCreateModalForm.vue";


import moment from 'moment';

@Component({
    components: {FormGroup, VisitCreateModalForm},
    methods: {moment}
})
export default class VisitCreateFormComponent extends Vue {
    @Prop() form!:  VisitCreateForm;
}
